import React from 'react';
import { MapPin, Building2 } from 'lucide-react';
import { SavedLocation } from '@hero/schema';
import { locationAutocompleteAPI } from '@hero/api';

type SearchLocationData = locationAutocompleteAPI['data']['googlePlaces'][0];

export interface LocationItemProps {
  location: SavedLocation | SearchLocationData;
  type: 'saved' | 'google';
  onClick: () => void;
  isRTL?: boolean;
}

export function LocationItem({ location, type, onClick, isRTL }: LocationItemProps) {
  const isSaved = type === 'saved';
  const savedLocation = isSaved ? (location as SavedLocation) : null;
  const googlePlace = !isSaved ? (location as SearchLocationData) : null;

  const name = isSaved ? savedLocation!.name : googlePlace!.name;
  const address = isSaved
    ? savedLocation!.address?.fullAddress || ''
    : googlePlace!.fullAddress;

  return (
    <button
      type="button"
      onMouseDown={e => {
        // Use onMouseDown to fire before blur event
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className="w-full text-left px-3 py-2 hover:bg-gray-100 rounded-md flex items-start gap-2">
      {isSaved ? (
        <Building2 className="h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0" />
      ) : (
        <MapPin className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
      )}
      <div className={`flex-1 min-w-0 ${isRTL ? 'text-right' : ''}`}>
        <div className="font-medium text-sm">{name}</div>
        <div className="text-xs text-gray-500 truncate">{address}</div>
      </div>
    </button>
  );
}
